import { pathgen } from 'object-path-generator';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useUpdateNotificationSettingsV2TestIds = pathgen('useUpdateNotificationSettingsV2TestIds');
export const useUpdateNotificationSettingsV2 = function useUpdateNotificationSettingsV2() {
    let { onSuccess } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { mutate, isLoading, error } = useMutationState({
        mutationFn: (args)=>api.notification.updateNotificationSettingsV2(args),
        toasts: {
            successMessage: commonTexts.toasts.notificationSettingsUpdatedSuccessfully(),
            successTestId: useUpdateNotificationSettingsV2TestIds.SuccessToast()
        },
        onSuccess
    });
    return {
        update: mutate,
        isLoading,
        error
    };
};
